import contextHelper, { knownContexts } from './context'
import { importRemoteEntry } from './webpackRemoteEntries'

let generatedLinks = null
let tenantConfig = null

function getContextRoute (brandConfig, contextName) {
  const contexts = contextHelper.getAvailableContexts(brandConfig)
  const contextRoute = contexts?.find(ctx => ctx.name === contextName)?.path ?? `${contextName}`
  return contextRoute.replace(/^\//, '').replace(/\/$/, '')
}

function getMfeRoutes (brandConfig, contextName) {
  const contextRoute = getContextRoute(brandConfig, contextName)
  return {
    contextRoute: `/${contextRoute}`,
    routerBase: `/__publicPath__/${contextRoute}`,
    resourceBase: `/__publicPath__/${contextName}/resources`
  }
}

async function generateImports (brandConfig) {
  const contextRoutes = Object.values(knownContexts).reduce((routes, contextName) => {
    routes[contextName] = getMfeRoutes(brandConfig, contextName)
    return routes
  }, {})
  const imports = {
    mfe_orders_energy: {
      name: 'mfe_orders_energy',
      // label: 'context.profile.label',
      route: contextRoutes[knownContexts.energy].contextRoute,
      loadApp: async () => await importRemoteEntry('mfe_orders_energy/singleSpa'),
      buildActivityFn: true,
      opts: {
        contextName: knownContexts.energy,
        routerBase: contextRoutes[knownContexts.energy].routerBase,
        resourceBase: contextRoutes[knownContexts.energy].resourceBase,
        backendBase: '/mfe_orders_energy',
        brandConfigBaseProvider: () => brandConfig
      }
    }
  }
  return imports
}

async function generateLinks (imports, config = tenantConfig) {
  if (generatedLinks) return generatedLinks
  if (!tenantConfig) tenantConfig = config
  // const roles = await loadRoles()
  const links = []

  for (const [, app] of Object.entries(imports)) {
    const appAvailable = app?.opts.contextName ? await contextHelper.hasContext(app.opts.contextName, config) : false // && await checkAuthorization(roles[name])
    if (appAvailable) {
      links.push({ name: app.name, label: app.label, icon: app.opts.icon, contextName: app.opts.contextName, route: app.route, baseRoute: app.opts.routerBase })
    }
  }

  generatedLinks = links
  return generatedLinks
}

export default { generateImports, generateLinks }
